<div class="cd-waring-popup-box">
  <div class="cd-waring-popup">
    <span class="cds-body-hero">{{ data.title | lang }}</span>
    <div class="l-mt-4">
      @for (msg of data.messages; track msg) {
      <div class="cds-body-hero cds-body1 l-mb-0">
        {{ msg }}
      </div>
      }
    </div>
    <div class="botton-list">
      @for (button of data.buttons; track button) {
      <cds-button [style]="button.style" [size]="button.size" (click)="button.cb()">{{ button.text | lang }}</cds-button>
      }
    </div>
  </div>
  <!-- <cds-icon
  *ngIf="data.isShowCloseIcon"
  class="close-icon"
  icon="action:cross"
(click)="close()"></cds-icon> -->
</div>
